module.exports = __webpack_public_path__ + "img/eltesoro.32b0c6e0.png";